import React, { Component } from 'react'
import MenuItem from './MenuItem.jsx'
import formatMenuItems from '../functions/formatMenuItems'
import SiteNavigationMoreButton from './SiteNavigationMoreButton.jsx';
import decodeHtml from '../functions/decodeHtml'
import MenuItemLanguageChooser from './MenuItemLanguageChooser.jsx';

let allItemsWidth = []


class MenuItemsList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            allItemsWidthState: [],
            menuWidthState: 0
        }

        this.getItemWidth = this.getItemWidth.bind(this)
    }

    getItemWidth(width, ID) {
        const alreadyInArray = _.filter(allItemsWidth, (item) => {
            return item.ID === ID
        })
        
        if(alreadyInArray.length === 0) {
            allItemsWidth.push({width, ID})
    
            this.setState({
                allItemsWidthState: allItemsWidth
            })
        }
    }

    componentDidMount() {
        const {menuWidth} = this.props
        if(menuWidth && menuWidth !== this.state.menuWidthState) {
            this.setState({
                menuWidthState: menuWidth
            })
        }
    }

    componentDidUpdate() {
        const {menuWidth} = this.props
        if(menuWidth && menuWidth !== this.state.menuWidthState) {
            this.setState({
                menuWidthState: menuWidth
            })
        }
    }

    render() {  
        const { menuItemsData, programOverviewSubmenus, translation, isMobile, attributes, maxWidthForItems, hiddenMenuOpen, onMouseLeave, onMouseEnter, getMoreButtonWidth, onClick, onToggleNavigation } = this.props
        let sum = 0
        let visibleMenuItems = []
        let hiddenMenuItems = []
        
        for (var i = 0; i < allItemsWidth.length; i++) {
            const width = allItemsWidth[i].width
            
            if (maxWidthForItems > (sum + width)) {
                if(!(_.contains(hiddenMenuItems, allItemsWidth[i].ID)) && !(_.contains(visibleMenuItems, allItemsWidth[i].ID))) {
                    sum += allItemsWidth[i].width
                    visibleMenuItems.push(allItemsWidth[i].ID)
                }
            } else {
                if(!(_.contains(hiddenMenuItems, allItemsWidth[i].ID)) && !(_.contains(visibleMenuItems, allItemsWidth[i].ID))) {
                    sum += allItemsWidth[i].width
                    hiddenMenuItems.push(allItemsWidth[i].ID)
                }
            }
        }

        const menuItems = menuItemsData.items
        const menuItemsOrder = menuItemsData.order
     
        const parentMenuItems = _.filter(menuItems, (menuItem) => {
            return menuItem.menu_item_parent === '0'
        })
        const menuItemsArray = []

        if(!menuItems || !menuItemsOrder) {
            return ''
        }

        const needSpace = (visibleMenuItems.length === parentMenuItems.length || hiddenMenuItems.length === 0) ? false : true
        if(visibleMenuItems.length !== 0 && hiddenMenuOpen === false && visibleMenuItems.length !== menuItemsOrder.length) {
            visibleMenuItems.map(itemId => {
                if(! _.contains(menuItemsArray, menuItems[itemId])) {
                    menuItemsArray.push(menuItems[itemId])
                }
                
            })
        } else if(hiddenMenuItems.length !== 0 && hiddenMenuOpen === true  && visibleMenuItems.length !== menuItemsOrder.length) {
            hiddenMenuItems.map(itemId => {
                if(! _.contains(menuItemsArray, menuItems[itemId])) {
                    menuItemsArray.push(menuItems[itemId])
                }
            })
        } else {
            menuItemsOrder.map(itemId => {
                if(! _.contains(menuItemsArray, menuItems[itemId])) {
                    menuItemsArray.push(menuItems[itemId])
                }
            })
        }

        const formatedMenuItems = formatMenuItems(menuItemsArray)

        const itemList = formatedMenuItems.map((menuItem, index) => {
            const { ID, title } = menuItem
            const decodeTitle = decodeHtml(title)
            var Mobile = /Mobile/.test(navigator.userAgent) && !window.MSStream
        
            // if(Mobile && menuItem.url === programOverviewUrl) {
            //     return ''
            // }
            
            return (
                <MenuItem
                    ID={ID} 
                    index={index}
                    isLast={(formatedMenuItems.length === index + 1)}
                    key={index} 
                    menuItem={menuItem}
                    attributes={attributes}
                    programOverviewSubmenus={programOverviewSubmenus}
                    title={decodeTitle}
                    getItemWidth={this.getItemWidth}
                    onMouseEnter={onMouseEnter}
                    translation={translation}
                    onMouseLeave={onMouseLeave}
                    onToggleNavigation={onToggleNavigation}
                />
            )
        })

        if(isMobile) {
            return itemList
        } else {
            return (
                <ul className={"menu"}>
                    {itemList}
                    {needSpace && <SiteNavigationMoreButton
                        getMoreButtonWidth={getMoreButtonWidth}
                        translation={translation}
                        hiddenMenuOpen={hiddenMenuOpen}
                        onClick={onClick} 
                    />}
                    {translation.languages && <MenuItemLanguageChooser 
                        translation={translation}
                    />}

                </ul>
            )
        }
    }
}

export default MenuItemsList